// @ts-ignore wat https://www.destroyallsoftware.com/talks/wat
import type * as SchemaTypes from '../../../graphql/api/index';

import { gql } from 'graphql-tag';
import { ProductLinkFragmentDoc } from '../../../router/fragments/productLink.fragment.generated';
import { MetalVariationFragmentDoc } from '../../rings/MetalVariations.generated';
import { GetIsLabGrownFragmentDoc } from '../../../domain/product/getIsLabGrown.generated';
import { MoneyFragmentDoc } from '../../../graphql/api/fragments/money.fragment.generated';
import { MonolithImageSizeFragmentDoc } from '../../useImageProps.generated';
export const ProductCardFragmentDoc = gql`
    fragment productCard on CatalogueProduct {
  __typename
  catalogueCode
  productName
  ...productLink
  ...metalVariation
  ...getIsLabGrown
  supportsExpress
  salePrice(currency: $currency, country: $country) {
    __typename
    total {
      ...money
    }
  }
  images(limit: 4) {
    __typename
    url
    medium: size(name: MEDIUM) {
      ...monolithImageSize
    }
    medium_x2: size(name: MEDIUM_X2) {
      ...monolithImageSize
    }
  }
  reviewsAggregate {
    __typename
    total
    rating
  }
  ... on CatalogueReadyToGoRing {
    shortName
    shortDescription
  }
  ... on CatalogueWeddingRing {
    translation(locale: $locale) {
      seoText
      description
    }
  }
  ... on CatalogueEngagementRing {
    centreStoneConstraints {
      shape {
        systemCode
      }
    }
    translation(locale: $locale) {
      seoText
      description
    }
  }
  ... on CatalogueJewelleryBracelet {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryEarrings {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryNecklace {
    translation(locale: $locale) {
      description
    }
  }
  ... on CatalogueJewelleryRing {
    translation(locale: $locale) {
      description
    }
  }
}
    ${ProductLinkFragmentDoc}
${MetalVariationFragmentDoc}
${GetIsLabGrownFragmentDoc}
${MoneyFragmentDoc}
${MonolithImageSizeFragmentDoc}`;